import { useEffect, useState } from "react";
import Dashboard from "../dashboard/Dashboard";
import Card from "../../components/cards/Card";
import { NavLink } from "react-router-dom";
import style from "./partners.module.scss";
import {
  getTotalPartnersByStatus,
  PartnerStatus,
} from "../../services/partner.service";
import showToast from "../../utils/show.toast";

export default function PartnerDashboard() {
  const [isLoadingPartnersCount, setIsLoadingPartnersCount] =
    useState<boolean>(false);
  const [partnersCount, setPartnersCount] =
    useState<Record<PartnerStatus, number>>();

  const fetchData = async () => {
    setIsLoadingPartnersCount(true);
    try {
      const partnerResponse = await getTotalPartnersByStatus();
      setPartnersCount(partnerResponse);
    } catch (error) {
      showToast("Error fetching partners stats", false);
      return;
    } finally {
      setIsLoadingPartnersCount(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Dashboard pageTitle="Partners">
      <section className={style.cardContainer}>
        <NavLink to={`/partners/list?status=${PartnerStatus.REGISTERED}`}>
          <Card
            title="Unreviewed"
            description="Total number of partners registered in the system."
            isLoading={isLoadingPartnersCount}
            number={partnersCount?.registered ?? 0}
          />
        </NavLink>

        <NavLink to={`/partners/list?status=${PartnerStatus.ACCEPTED}`}>
          <Card
            title="Approved"
            description="Total number of partners registered in the system."
            isLoading={isLoadingPartnersCount}
            number={partnersCount?.accepted ?? 0}
          />
        </NavLink>

        <NavLink to={`/partners/list?status=${PartnerStatus.VERIFIED}`}>
          <Card
            title="Verified"
            description="Total number of partners registered in the system."
            isLoading={isLoadingPartnersCount}
            number={partnersCount?.verified ?? 0}
          />
        </NavLink>

        <NavLink to={`/partners/list?status=${PartnerStatus.SUSPENDED}`}>
          <Card
            title="Suspended"
            description="Total number of partners registered in the system."
            isLoading={isLoadingPartnersCount}
            number={partnersCount?.suspended ?? 0}
          />
        </NavLink>
      </section>
    </Dashboard>
  );
}
